import React from "react";
import { Tooltip } from "antd";

interface TruncatedFileNamesProps {
  fileNames: Array<string>;
  maxLength: number;
  keyProp: string;
}

const TruncatedFileNames: React.FC<TruncatedFileNamesProps> = ({
  fileNames = [],
  maxLength = 0,
  keyProp = "",
}) => {
  let result = fileNames.reduce(
    (prev, next) => ({
      text:
        prev.text.length + next.length > maxLength && prev.missing === 0
          ? prev.text
          : prev.text.length === 0
          ? next
          : `${prev.text}, ${next}`,
      missing:
        prev.text.length + next.length > maxLength
          ? prev.missing + 1
          : prev.missing,
    }),
    { text: "", missing: 0 }
  );

  return result.missing === 0 ? (
    <>{result.text}</>
  ) : (
    <Tooltip
      placement="bottom"
      title={
        <>
          {fileNames.map((fileName, index) => (
            <p key={`fp-${keyProp}-${index}`}>{fileName}</p>
          ))}
        </>
      }
    >
      {`${result.text} +${result.missing}`}
    </Tooltip>
  );
};

export default TruncatedFileNames;
